import { colors } from '../foundation';

type Props = {
  color?: typeof colors.primary.red | typeof colors.primary.white;
};

const NoWifi = ({ color = colors.primary.white }: Props) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Network &#38; Coverage/no-wifi">
        <path
          id="Vector"
          d="M4.19141 15.8333C12.9284 7.08984 27.1016 7.08333 35.8451 15.8203L35.8581 15.8333M8.71615 20.5208C14.9531 14.2773 25.0833 14.2708 31.3268 20.5078L31.3398 20.5208M7.41406 32.6172L32.6419 7.38281M13.4557 25.8073C17.082 22.1745 22.9674 22.1745 26.6003 25.8073M20.8581 31.7187C20.8581 32.181 20.487 32.5521 20.0247 32.5521C19.569 32.5521 19.1914 32.181 19.1914 31.7187C19.1914 31.2565 19.569 30.8854 20.0247 30.8854C20.487 30.8854 20.8581 31.2565 20.8581 31.7187ZM20.5456 31.7187C20.5456 32.0052 20.3177 32.2396 20.0247 32.2396C19.7383 32.2396 19.5039 32.0052 19.5039 31.7187C19.5039 31.4323 19.7383 31.1979 20.0247 31.1979C20.3177 31.1979 20.5456 31.4323 20.5456 31.7187ZM20.2331 31.7187C20.2331 31.8359 20.1419 31.9271 20.0247 31.9271C19.9141 31.9271 19.8164 31.8359 19.8164 31.7187C19.8164 31.6016 19.9141 31.5104 20.0247 31.5104C20.1419 31.5104 20.2331 31.6016 20.2331 31.7187Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default NoWifi;
